import AddUserIcon from 'components/ReusableComponents/Icons/AddUser'
import React from 'react'

import styles from './ContactTile.module.scss'
import HistoryIcon from './history.svg'
/**
 *
 * @typedef {object} ContactTileProps
 * @property {string} name
 * @property {string} email
 * @property {string} phone
 * @property {() => void} onClickAdd
 * @property {() => void} onClickHistory
 *
 * @param {ContactTileProps} props
 * @returns
 */
const ContactTile = ({ name, email, phone, onClickAdd, onClickHistory }) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleCol}>
        <p className={styles.title}>{name}</p>

        <div className={styles.emailPhoneRow}>
          <p className={styles.email}>{email}</p>
          <div className={styles.dot} />
          <p className={styles.phone}>{phone}</p>
        </div>
      </div>

      <img
        src={HistoryIcon}
        alt="HistoryIcon"
        className={styles.historyIcon}
        onClick={onClickHistory}
      />
      <AddUserIcon className={styles.addIcon} onClick={onClickAdd} />
    </div>
  )
}

export default ContactTile
